import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const SearchPopup = ({ isPopup, handlePopup }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const navigate = useNavigate(); // use for redirecting

 const handleSearch = (e) => {
    e.preventDefault();
    if (searchTerm.trim()) {
      const keyword = encodeURIComponent(searchTerm.trim());
      navigate(`/event?keyword=${keyword}`); 
    }
  };

  return (
    <div id="search-popup" className={`search-popup ${isPopup ? "active" : ""}`}>
  <div className="search-popup__overlay search-toggler" onClick={handlePopup} />
  <div className="search-popup__content">
    <form onSubmit={handleSearch}>
      <label htmlFor="search" className="sr-only">Search here</label>
      <input
        type="text"
        id="search"
        placeholder="Search Here..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />
      <button type="submit" aria-label="search submit" className="thm-btn">
        <i className="fas fa-search" />
      </button>
    </form>

  
  </div>
</div>
    // <div id="search-popup" className={`search-popup ${isPopup ? "active" : ""}`}>
    //   <div className="search-popup__overlay search-toggler" onClick={handlePopup} />
    //   <div className="search-popup__content">
    //     <form onSubmit={handleSearch}>
    //       <label htmlFor="search" className="sr-only">Search here</label>
    //       <input
    //         type="text"
    //         id="search"
    //         placeholder="Search Here..."
    //         value={searchTerm}
    //         onChange={(e) => setSearchTerm(e.target.value)}
    //       />
    //       <button type="submit" aria-label="search submit" className="thm-btn">
    //         <i className="fas fa-search" />
    //       </button>
    //     </form>

    //     {loading ? (
    //       <p>Loading...</p>
    //     ) : (
    //      <ul
    //             className="max-h-64 overflow-y-auto border border-gray-200 rounded p-2 space-y-4"
    //             >
    //             {posts.map(post => (
    //                 <li
    //                 key={post.id}
    //                 className="cursor-pointer p-2 hover:bg-gray-100 rounded transition"
    //                 onClick={() => window.location.href = `/event/${post.slug}`}
    //                 >
    //                 <h3
    //                     className="font-semibold text-blue-600"
    //                     dangerouslySetInnerHTML={{ __html: post.title.rendered }}
    //                 />
    //                 <div
    //                     className="text-sm text-gray-600"
    //                     dangerouslySetInnerHTML={{ __html: post.excerpt.rendered }}
    //                 />
    //                 </li>
    //             ))}
    //             </ul>
    //     )}
    //   </div>
    // </div>
  );
};

export default SearchPopup;
